import styles from './PaneResizer.module.css';

interface PaneResizerProps {
  onMouseDown: (e: React.MouseEvent) => void;
  onDoubleClick: () => void;
  role?: 'separator';
  title?: string;
  'aria-orientation'?: 'vertical' | 'horizontal';
  /** Eje que MUEVE el tirador: 'x' ajusta anchos, 'y' ajusta altos. Lo pone
   *  `useResizablePane`, así que no hay que pasarlo a mano. */
  'data-axis'?: 'x' | 'y';
}

/**
 * Thin draggable handle between two panes. Props come from
 * `useResizablePane().resizerProps` — just spread them here.
 *
 * El aspecto (barra vertical u horizontal) lo decide el CSS colgando de
 * `data-axis`, no una clase que haya que acordarse de pasar: el eje ya viaja
 * dentro de `resizerProps` y una segunda fuente para el mismo dato es cómo se
 * quedan desalineados.
 */
export function PaneResizer(props: PaneResizerProps) {
  return <div className={styles.resizer} {...props} />;
}
